import React from "react";
import * as S from './ManageTripCardMmtStyles';
import { HOB_BAGGAGE_ICON } from "../../../../../config/constants";
import ButtonMmt from "../ButtonMmt/ButtonMmt";

const ManageTripCardMmt = ({
    label= 'Manage Your Trip & Get All The Help',
    btnTxt='Go To My Trips',
    btnClickHandler
}) => {
    return (
      <S.ManageTripCard>
        <S.Label>{label}</S.Label>
        <S.BaggageIcon src={HOB_BAGGAGE_ICON}/>
        <ButtonMmt btnTxt={btnTxt} type={3} onClick={btnClickHandler} showIcon isCall = {false}/> 
      </S.ManageTripCard>
    );
};

export default ManageTripCardMmt;